import React from "react";
import { useSelector } from "react-redux";
import { Heading, RoleName2, SubHeading } from "./BlockParts";
import { useLocation } from "react-router-dom";

export default function RoleNameBlock2({ options, items, idx }) {
  let FontSettings = useSelector((state) => state.project?.fontStyle);
  const settings = useSelector((state) => state.project?.settings);
  const location = useLocation();
  const isCard = location.state?.isCard;

  return (
    <>
      {!isCard && (
        <div
          className="container p-1 "
          style={{ width: "100%", padding: "0px" }}
          id={"block_" + idx}
        >
          <div
            className="row"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col" style={{ width: "100%", padding: "0px" }}>
              <Heading
                options={options}
                fontStyle={FontSettings?.heading}
                idx={idx}
              />
            </div>
          </div>
          <div
            className="row"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col" style={{ width: "100%", padding: "0px" }}>
              <SubHeading
                options={options}
                fontStyle={FontSettings?.subHeading}
                idx={idx}
              />
            </div>
          </div>
          <div
            className="row w-full "
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col" style={{ width: "100%", padding: "0px" }}>
              <RoleName2
                options={options}
                fontStyle={FontSettings}
                idx={idx}
                items={items}
                settings={settings}
              />
            </div>
          </div>
        </div>
      )}
      {isCard && (
        <div
          className="  w-full"
          style={{ width: "100%", padding: "0px" }}
          id={"block_" + idx}
        >
          <div
            className="row"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col" style={{ width: "100%", padding: "0px" }}>
              <Heading
                options={options}
                fontStyle={FontSettings?.heading}
                idx={idx}
              />
            </div>
          </div>
          <div
            className="row"
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col" style={{ width: "100%", padding: "0px" }}>
              <SubHeading
                options={options}
                fontStyle={FontSettings?.subHeading}
                idx={idx}
              />
            </div>
          </div>
          <div
            className="row w-full  "
            style={{ marginLeft: "0px", marginRight: "0px" }}
          >
            <div className="col" style={{ width: "100%", padding: "0px" }}>
              <RoleName2
                options={options}
                fontStyle={FontSettings}
                idx={idx}
                items={items}
                settings={settings}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
